import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '@xo-union/tk-component-icons';
import {StatusBadge} from '@xo-union/tk-component-badges';
import {Caption} from '@xo-union/tk-ui-typography';
import {compose} from '@xo-union/react-css-modules';
import {
  ADVERTISEMENT_PLACEMENTS,
  ADVERTISEMENT_VIEWS,
  advertisementData,
} from '../../data';
import style from './style.scss';

const badgeClasses = compose({container: style.badge});

const AdvertisementCard = ({view, placement, partner, isBanner}) => {
  const {
    company,
    imageSource,
    linkText,
    placementLinks,
    [view]: viewCopy,
  } = advertisementData[partner];
  const link = placementLinks[placement];

  if (!link) return null;

  return (
    <section
      className={cx(style.advertisement, isBanner && style.banner)}
      aria-label="Advertisement">
      <div className={style.branding}>
        {imageSource ? (
          <img
            src={imageSource}
            alt={company}
            className={style.logo}
            loading="lazy"
            decoding="async"
          />
        ) : (
          <span className={style['logo-text']}>{company}</span>
        )}
        <Caption as="p" className={style.subtext}>
          {viewCopy.text}
        </Caption>
      </div>

      <div className={style.actions}>
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className={style.link}>
          {linkText}
          <Icon name="linkout" size="sm" aria-hidden="true" />
        </a>
        <StatusBadge type="neutral" size="lg" classes={badgeClasses}>
          Ad
        </StatusBadge>
      </div>
    </section>
  );
};

AdvertisementCard.propTypes = {
  isBanner: PropTypes.bool,
  partner: PropTypes.oneOf(Object.keys(advertisementData)).isRequired,
  placement: PropTypes.oneOf(ADVERTISEMENT_PLACEMENTS).isRequired,
  view: PropTypes.oneOf(ADVERTISEMENT_VIEWS).isRequired,
};

AdvertisementCard.defaultProps = {
  isBanner: false,
};

export default AdvertisementCard;
